export const CandidateOwnership = () => {
  return (
    <div className="max-w-7xl mx-auto px-6">
        <div className="bg-[#53B9D4] pt-[35px] px-6 md:px-10 pb-[70px] rounded-[40px]">
            <p className="text-center font-oxanium text-3xl sm:text-6xl leading-[50px] sm:leading-[80px] xl:text-[64px] xl:leading-[130px] font-medium text-[#001115]">Reach More Talent Without Losing Ownership</p>
            <p className="font-lato font-light text-xl lg:text-2xl flex sm:justify-center mt-4 flex-wrap">Share or borrow candidates securely with credits, insights, and full transparency</p>
        </div>
    </div>
  )
}
